export const OPENNETWORK_DOMAINS_RESET_STATE = 'OPENNETWORK_DOMAINS_RESET_STATE';
export const OPENNETWORK_DOMAINS_CURRENT_ITEM = 'OPENNETWORK_DOMAINS_CURRENT_ITEM';

export const OPENNETWORK_DOMAINS_REQUEST_LOADING = 'OPENNETWORK_DOMAINS_REQUEST_LOADING';
export const OPENNETWORK_DOMAINS_REQUEST_SUCCESS = 'OPENNETWORK_DOMAINS_REQUEST_SUCCESS';
export const OPENNETWORK_DOMAINS_REQUEST_FAILED = 'OPENNETWORK_DOMAINS_REQUEST_FAILED';

export const OPENNETWORK_DOMAINS_CURRENT_ACTION = 'OPENNETWORK_DOMAINS_CURRENT_ACTION';
export const OPENNETWORK_DOMAINS_RESET_ACTION = 'OPENNETWORK_DOMAINS_RESET_ACTION';